// extracted by mini-css-extract-plugin
export default {"label":"Label_label__gQPTE","required":"Label_required__zr6oE"};